angular.module('storefront.account')
    .component('vcAccountAddresses', {
        templateUrl: 'themes/assets/js/account/account-addresses.tpl.liquid',
        require: {
            accountManager: '^vcAccountManager',
        },
        controller: [
            'storefrontApp.mainContext',
            'confirmDialogService',
            '$translate',
            '$scope',
            'loadingIndicatorService',
            'dialogService',
            'rsAddressValidateService',
            function (
                mainContext,
                confirmDialogService,
                $translate,
                $scope,
                loader,
                dialogService,
                rsAddressValidateService,
            ) {
                const $ctrl = this;
                $ctrl.loader = loader;

                $scope.$watch(
                    function () {
                        return mainContext.customer.addresses;
                    },
                    function () {
                        $ctrl.addresses = mainContext.customer.addresses;
                    },
                );

                $ctrl.addNewAddress = function () {
                    if (_.last(components).validate()) {
                        rsAddressValidateService.validate($ctrl.newAddress)
                            .then(function (response) {
                                if (response.data.addressIsValid) {
                                    $ctrl.addresses.push($ctrl.newAddress);
                                    $ctrl.newAddress = null;
                                    $ctrl.accountManager.updateAddresses($ctrl.addresses);
                                    return;
                                }

                                $ctrl.addressInvalid = true;

                                if (response.data.matches.length) {
                                    showAddressMatchesDialog(response.data.matches, $ctrl.newAddress);
                                }
                            });
                    }
                };

                $ctrl.cancel = function () {
                    $ctrl.editIdx = -1;
                    $ctrl.editItem = null;
                    $ctrl.addressInvalid = false;
                    $ctrl.newAddress = null;
                };

                $ctrl.edit = function ($index) {
                    $ctrl.editIdx = $index;
                    $ctrl.editItem = angular.copy($ctrl.addresses[$ctrl.editIdx]);
                };

                $ctrl.submitEdit = function () {
                    if (components[$ctrl.editIdx].validate()) {
                        rsAddressValidateService.validate($ctrl.editItem)
                            .then(function (response) {
                                if (response.data.addressIsValid) {
                                    angular.copy($ctrl.editItem, $ctrl.addresses[$ctrl.editIdx]);
                                    $ctrl.accountManager.updateAddresses($ctrl.addresses)
                                        .then($ctrl.cancel);
                                    return;
                                }

                                $ctrl.addressInvalid = true;

                                if (response.data.matches.length) {
                                    showAddressMatchesDialog(response.data.matches, $ctrl.editItem);
                                }
                            });
                    }
                };

                $ctrl.delete = function ($index) {
                    const showDialog = function (text) {
                        confirmDialogService.confirm(text, function (confirmed) {
                            if (confirmed) {
                                $ctrl.addresses.splice($index, 1);
                                $ctrl.accountManager.updateAddresses($ctrl.addresses);
                            }
                        });
                    };

                    $translate('customer.addresses.delete_confirm')
                        .then(showDialog, showDialog);
                };

                let components = [];
                $ctrl.addComponent = function (component) {
                    components.push(component);
                };
                $ctrl.removeComponent = function (component) {
                    components = _.without(components, component);
                };

                function showAddressMatchesDialog(matches, targetObject) {
                    dialogService.showDialog(
                        {
                            matches,
                            countries: $ctrl.accountManager.availCountries,
                        },
                        'addressMatchesDialogController',
                        'storefront.address-matches-dialog.tpl',
                        function (result) {
                            if (result) {
                                Object.assign(targetObject, result);
                                $ctrl.addressInvalid = false;
                            }
                        },
                    );
                }
            }],
    });
